import { useResizeObserver } from '@wojtekmaj/react-hooks';
import React, { useCallback, useRef, useState } from 'react';
import { Document, Page } from 'react-pdf';
import styles from './pdf.less';

interface PDFProps {
  file: File;
}

export const PDF = ({ file }: PDFProps) => {
  const [numberOfPages, setNumberOfPages] = useState<number>();
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number>();
  const maxWidth = containerRef.current?.clientWidth ?? 800;

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;

    if (entry) {
      setContainerWidth(entry.contentRect.width);
    }
  }, []);

  useResizeObserver(containerRef.current, undefined, onResize);

  return (
    <div ref={containerRef} className={styles.pdfContainer}>
      <Document
        file={file}
        loading="Loading PDF..."
        externalLinkTarget="_blank"
        onLoadSuccess={({ numPages }) => {
          setNumberOfPages(numPages);
        }}
      >
        {Array.from(new Array(numberOfPages), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
          />
        ))}
      </Document>
    </div>
  );
};
